/* eslint-disable */
import React, {useEffect, useState} from "react";
import {useAuth} from "../../contexts/AuthProvider";
import DashboardTabToggle from "./DashboardTabToggle";
import BarChartComponent from "./BarChartComponent";
import LineChartComponent from "./LineChartComponent";
import CardChartComponent from "./CardChartComponent";
import DateRangeFilter from "../filters/DateRangeFilter";
import SelectFilter from "../filters/SelectFilter";
import UserDropdown from "../users/UserDropdown";
import FilterBadge from "./FilterBadge";
import {
    getDashboardData,
    getMostCommonItemData,
    getRegisterPerMonthData,
    getRegisterPerGenderData,
    getDashboardFiltersOptions
} from "../../services/dashboardService";
import "./Dashboard.css";
import CircularProgress from "@mui/material/CircularProgress";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import TroubleshootIcon from "@mui/icons-material/Troubleshoot";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Box from "@mui/material/Box";
import PieChartComponent from "./PieChartComponent";
import PatientListModal from "../dashboard/PatientsListModal";

function Dashboard() {
    const {userToken} = useAuth();
    const [dashboardData, setDashboardData] = useState(null);
    const [activeTab, setActiveTab] = useState("Doenças");
    const [isLoading, setIsLoading] = useState(false);

    const [currentSelectedDoenca, setCurrentSelectedDoenca] = useState(null);
    const [currentSelectedMedicamento, setCurrentSelectedMedicamento] = useState(null);
    const [currentSelectedProcedimento, setCurrentSelectedProcedimento] = useState(null);
    const [currentStartDate, setCurrentStartDate] = useState(null);
    const [currentEndDate, setCurrentEndDate] = useState(null);

    const [doencaOptions, setDoencaOptions] = useState([]);
    const [medicamentoOptions, setMedicamentoOptions] = useState([]);
    const [procedimentoOptions, setProcedimentoOptions] = useState([]);

    const [patientsModalOpen, setPatientsModalOpen] = useState(false);
    const [patientList, setPatientList] = useState([]);

    const handleOpenPatientsModal = () => {
        setPatientList(dashboardData.patientList);
        setPatientsModalOpen(true);
    };

    const tabs = ["Doenças", "Medicamentos", "Procedimentos"];

    useEffect(() => {
        setFiltersOptions(userToken, null)
    }, []);

    const fetchDashboardData = async (
        tab = activeTab,
        selectedDoenca = currentSelectedDoenca,
        selectedMedicamento = currentSelectedMedicamento,
        selectedProcedimento = currentSelectedProcedimento,
        startDateFilter = currentStartDate,
        endDateFilter = currentEndDate
    ) => {
        setIsLoading(true);
        try {
            const data = await getDashboardData(
                userToken,
                tab,
                selectedDoenca,
                selectedMedicamento,
                selectedProcedimento,
                startDateFilter,
                endDateFilter
            );
            setDashboardData(data);
            updateFilters(data);
        } catch (error) {
            console.error("Erro ao carregar os dados do dashboard:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        fetchDashboardData(tabName);
    };

    const cleanFilter = (fetch = true) => {
        setCurrentSelectedDoenca(null);
        setCurrentSelectedMedicamento(null);
        setCurrentSelectedProcedimento(null);
        setCurrentStartDate(null);
        setCurrentEndDate(null);
        if (fetch) fetchDashboardData(activeTab, null, null, null, null, null);
    };

    const handleBarClick = (item) => {
        if (activeTab === "Doenças") {
            const updated = currentSelectedDoenca ? [...currentSelectedDoenca] : [];
            if (!updated.includes(item)) {
                const newVal = [...updated, item];
                setCurrentSelectedDoenca(newVal);
                fetchDashboardData(activeTab, newVal);
            }
        } else if (activeTab === "Medicamentos") {
            const updated = currentSelectedMedicamento ? [...currentSelectedMedicamento] : [];
            if (!updated.includes(item)) {
                const newVal = [...updated, item];
                fetchDashboardData(activeTab, currentSelectedDoenca, newVal);
                setCurrentSelectedMedicamento(newVal);
            }
        } else if (activeTab === "Procedimentos") {
            const updated = currentSelectedProcedimento ? [...currentSelectedProcedimento] : [];
            if (!updated.includes(item)) {
                const newVal = [...updated, item];
                fetchDashboardData(activeTab, currentSelectedDoenca, currentSelectedMedicamento, newVal);
                setCurrentSelectedProcedimento(newVal);
            }
        }
    };


    const setFiltersOptions = async (token, patientId) => {
        const filtersOptions = await getDashboardFiltersOptions(token, patientId)
        const format = (list) => list.map((v) => ({label: v, value: v}));
        setDoencaOptions(format(filtersOptions.doencaOptions));
        setMedicamentoOptions(format(filtersOptions.medicamentoOptions));
        setProcedimentoOptions(format(filtersOptions.procedimentoOptions));
    }

    const updateFilters = (data) => {
        setCurrentSelectedDoenca(data.doencaFilter);
        setCurrentSelectedMedicamento(data.medicamentoFilter);
        setCurrentSelectedProcedimento(data.procedimentoFilter);
        setCurrentStartDate(data.startDateFilter);
        setCurrentEndDate(data.endDateFilter);
    };

    const getCardChartPatientsSubtitle = (hidden) => {
        const allItems = [
            ...(dashboardData.doencaFilter || []),
            ...(dashboardData.medicamentoFilter || []),
            ...(dashboardData.procedimentoFilter || [])
        ];

        if (allItems.length === 0) return "";

        let title = "com registro de ";
        let currentLength = title.length;
        let visibleItems = [];
        let hiddenCount = 0;

        for (const item of allItems) {
            if (hidden || currentLength + item.length + 2 <= 60) {
                visibleItems.push(item);
                currentLength += item.length + 2;
            } else {
                hiddenCount++;
            }
        }

        if (visibleItems.length === 1) {
            title += visibleItems[0];
        } else if (visibleItems.length === 2) {
            title += visibleItems.join(" e ");
        } else if (visibleItems.length > 2) {
            const lastItem = visibleItems.pop();
            title += visibleItems.join(", ") + " e " + lastItem;
        }

        if (hiddenCount > 0) {
            title += ` e mais ${hiddenCount}...`;
        }

        return title;
    };

    const getRegisterPerGenderPercentage = (index) => {
        if (!dashboardData || !dashboardData.registerPerGender) return "0%";
        const keys = Object.keys(dashboardData.registerPerGender);
        const value = dashboardData.registerPerGender[keys[index]];
        const total = Object.values(dashboardData.registerPerGender).reduce((sum, val) => sum + val, 0);
        if (!value || total === 0) return "0%";
        return (Math.round((value / total) * 10000) / 100).toFixed(2) + "%";
    };

    const getRegisterPerGenderPercentageSubtitle = (index) => {
        if (!dashboardData || !dashboardData.registerPerGender) return "0";
        const keys = Object.keys(dashboardData.registerPerGender);
        const value = dashboardData.registerPerGender[keys[index]];
        return `(${value.toLocaleString("pt-BR")})`;
    };

    const formatDateBR = (dateStr) => {
        const [year, month, day] = dateStr.split("-");
        return `${day}/${month}/${year}`;
    };

    useEffect(() => {
        fetchDashboardData(activeTab);
        // eslint-disable-next-line
    }, []);

    if (!dashboardData) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="100vh"
            >
                <CircularProgress/>
            </Box>
        );
    }

    return (
        <>
            <div className="dashboard-main-content">
                <div className="dashboard-title-container">
                    <h3 className="dashboard-title">Dashboard</h3>
                    <UserDropdown/>
                </div>

                <div className="card filters-card">
                    <div className="filter-title-container">
                        <h5 className="filter-title">Filtros</h5>
                        <DashboardTabToggle tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick}/>
                    </div>

                    <div className="row filters-container">
                        <SelectFilter title="Doença" currentSelected={currentSelectedDoenca} options={doencaOptions}
                                      onChange={(v) => {
                                          setCurrentSelectedDoenca(v);
                                          fetchDashboardData(activeTab, v);
                                      }} isClearable isMulti/>
                        <SelectFilter title="Medicamento" currentSelected={currentSelectedMedicamento}
                                      options={medicamentoOptions} onChange={(v) => {
                            setCurrentSelectedMedicamento(v);
                            fetchDashboardData(activeTab, currentSelectedDoenca, v);
                        }} isClearable isMulti/>
                        <SelectFilter title="Procedimento" currentSelected={currentSelectedProcedimento}
                                      options={procedimentoOptions} onChange={(v) => {
                            setCurrentSelectedProcedimento(v);
                            fetchDashboardData(activeTab, currentSelectedDoenca, currentSelectedMedicamento, v);
                        }} isClearable isMulti/>
                        <DateRangeFilter title="Período" onChangeStart={(v) => {
                            setCurrentStartDate(v);
                            fetchDashboardData(activeTab, currentSelectedDoenca, currentSelectedMedicamento, currentSelectedProcedimento, v, currentEndDate);
                        }} onChangeEnd={(v) => {
                            setCurrentEndDate(v);
                            fetchDashboardData(activeTab, currentSelectedDoenca, currentSelectedMedicamento, currentSelectedProcedimento, currentStartDate, v);
                        }} startDate={currentStartDate} endDate={currentEndDate}/>
                        <div className="filter-btn-container col-12 col-md-12 col-lg-1">
                            <div className="btn btn-primary filter-btn" onClick={cleanFilter}>Limpar</div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 selected-filters d-flex flex-wrap gap-2">
                            {(currentSelectedDoenca || []).map((item, idx) => (
                                <FilterBadge key={`doenca-${idx}`} label={item} category="Doença" onRemove={() => {
                                    const updated = currentSelectedDoenca.filter((_, i) => i !== idx);
                                    const newVal = updated.length ? updated : null;
                                    setCurrentSelectedDoenca(newVal);
                                    fetchDashboardData(activeTab, newVal);
                                }}/>
                            ))}
                            {(currentSelectedMedicamento || []).map((item, idx) => (
                                <FilterBadge key={`med-${idx}`} label={item} category="Medicamento" onRemove={() => {
                                    const updated = currentSelectedMedicamento.filter((_, i) => i !== idx);
                                    const newVal = updated.length ? updated : null;
                                    setCurrentSelectedMedicamento(newVal);
                                    fetchDashboardData(activeTab, currentSelectedDoenca, newVal);
                                }}/>
                            ))}
                            {(currentSelectedProcedimento || []).map((item, idx) => (
                                <FilterBadge key={`proc-${idx}`} label={item} category="Procedimento" onRemove={() => {
                                    const updated = currentSelectedProcedimento.filter((_, i) => i !== idx);
                                    const newVal = updated.length ? updated : null;
                                    setCurrentSelectedProcedimento(newVal);
                                    fetchDashboardData(activeTab, currentSelectedDoenca, currentSelectedMedicamento, newVal);
                                }}/>
                            ))}
                            {currentStartDate && (
                                <FilterBadge
                                    label={`De ${formatDateBR(currentStartDate)}`}
                                    category="Data"
                                    onRemove={() => {
                                        setCurrentStartDate(null);
                                        fetchDashboardData(
                                            activeTab,
                                            currentSelectedDoenca,
                                            currentSelectedMedicamento,
                                            currentSelectedProcedimento,
                                            null,
                                            currentEndDate
                                        );
                                    }}
                                />
                            )}

                            {currentEndDate && (
                                <FilterBadge
                                    label={`Até ${formatDateBR(currentEndDate)}`}
                                    category="Data"
                                    onRemove={() => {
                                        setCurrentEndDate(null);
                                        fetchDashboardData(
                                            activeTab,
                                            currentSelectedDoenca,
                                            currentSelectedMedicamento,
                                            currentSelectedProcedimento,
                                            currentStartDate,
                                            null
                                        );
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className="dashboard-charts" style={{position: "relative"}}>
                    {isLoading ?
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                backgroundColor: "rgba(255,255,255,0.6)",
                                backdropFilter: "blur(2px)",
                                WebkitBackdropFilter: "blur(2px)",
                                zIndex: 2,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <CircularProgress/>
                        </div> : null}

                    <div className="card most-common-graph-card">
                        <div className="graph-title-container">
                            <Box style={{color: "#0A91FF"}}>
                                <TravelExploreIcon/>
                            </Box>
                            <div className="graph-title">{activeTab} mais frequentes</div>
                        </div>
                        <BarChartComponent
                            options={getMostCommonItemData(dashboardData)}
                            onBarClick={handleBarClick}
                            selectedItems={
                                activeTab === "Doenças"
                                    ? currentSelectedDoenca
                                    : activeTab === "Medicamentos"
                                        ? currentSelectedMedicamento
                                        : currentSelectedProcedimento
                            }
                        />
                    </div>

                    <div className="quantity-graph-card">
                        <CardChartComponent title="Casos registrados"
                                            subtitle={<span>{getCardChartPatientsSubtitle()}</span>}
                                            value={dashboardData.totalCasesQuantity.toLocaleString("pt-BR")}/>
                        <CardChartComponent title="Pacientes"
                                            subtitle={<span>{getCardChartPatientsSubtitle()}</span>}
                                            value={dashboardData.patientsQuantity.toLocaleString("pt-BR")}
                                            onIconClick={handleOpenPatientsModal}
                                            className={`card-chart clickable ${patientsModalOpen ? 'active' : ''}`}
                        />
                    </div>

                    <div className="card time-graph-card">
                        <div className="graph-title-container">
                            <Box style={{color: "#5654D4"}}>
                                <TroubleshootIcon/>
                            </Box>
                            <div className="graph-title">
                                <span>Quantidade de casos ao longo do tempo {getCardChartPatientsSubtitle()}</span>
                            </div>
                        </div>
                        <LineChartComponent options={getRegisterPerMonthData(dashboardData)}
                                            onBarClick={handleBarClick}/>
                    </div>

                    <div className="card gender-graph-card">
                        <div className="gender-graph-card-content">
                            <div className="gender-graph-legend">
                                <div className="graph-title-container mb-3">
                                    <Box style={{color: "#5654D4"}}>
                                        <ContentPasteSearchIcon/>
                                    </Box>
                                    <div className="graph-title">Pacientes por gênero</div>
                                </div>
                                {["Feminino", "Masculino", "Não registrado"].map((label, i) => (
                                    <div className="gender-graph-legend-item-container" key={label}>
                                        <div className="gender-graph-legend-item">
                                            <Box style={{color: ["#9B55CA", "#0A91FF", "#83DBC9"][i]}}>
                                                <MoreVertIcon/>
                                            </Box>
                                            <div className="gender-graph-legend-text">{label}</div>
                                        </div>
                                        <div className="gender-graph-legend-percentage">
                                            <span>{getRegisterPerGenderPercentage(i)}</span>
                                            <span
                                                className="gender-graph-legend-percentage-subtitle">{getRegisterPerGenderPercentageSubtitle(i)}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <PieChartComponent options={getRegisterPerGenderData(dashboardData)}
                                               onBarClick={handleBarClick}/>
                        </div>
                    </div>
                </div>
            </div>
            <PatientListModal
                open={patientsModalOpen}
                onClose={() => setPatientsModalOpen(false)}
                patientList={patientList}
            />
        </>
    );
}

export default Dashboard;
